import moment from 'moment'
import { QuantityDto } from '../services/APIs/InternalAPI/internal-api.contracts'
import { formatFn } from './Quantity'

function getDuration(quantity: QuantityDto) {
  let durationUnit: 'h' | 'm' | 's' | 'ms'

  switch (quantity.unit) {
    case 'hrs': {
      durationUnit = 'h'
      break
    }
    case 'min': {
      durationUnit = 'm'
      break
    }
    case 'sec': {
      durationUnit = 's'
      break
    }
  }

  const duration = moment.duration(quantity.value || 0, durationUnit)

  return duration
}

export function TimeString(quantity: QuantityDto, returnDefault = false) {
  if (quantity?.value == null) {
    return returnDefault ? '00h 00m 00s' : ''
  }

  var duration = getDuration(quantity)

  const m = moment.utc(duration.asMilliseconds())

  return `${formatFn(Math.floor(duration.asHours()))}h ${formatFn(
    m.minute(),
  )}m ${formatFn(Math.round(m.second()))}s`
}

/**
 * Humanizes a time quantity (e.g., "a few seconds", "2 hours", "a day", etc.)
 * @param quantity the quantityDto to humanize (need to be a time)
 * @param minDurationToShowInHours will return empty string if duration is less than this value
 * @returns
 */
export function TimeStringHumanized(
  quantity: QuantityDto,
  minDurationToShowInHours = 0,
) {
  if (quantity?.value == null) {
    return ''
  }

  var duration = getDuration(quantity)

  if (duration.asHours() > minDurationToShowInHours) {
    return duration.humanize(false)
  }

  return ''
}
